import { useNavigate } from 'react-router-dom'

import { ChevronRight } from 'lucide-react'
import { cn } from '~/shadcn/lib/utils'

import { Button } from '~/shadcn/ui/button/button'
import { useSettings } from '~/@mid_settings/settings'

type FeeImmunityProps = {
  hasUserFeeImmunity: boolean
  isMobile: boolean
}

export function FeeImmunityButtons({
  hasUserFeeImmunity,
  isMobile,
}: FeeImmunityProps) {
  const navigate = useNavigate()

  const { getLandingPageLink } = useSettings()

  return (
    <div
      className={cn(
        'flex justify-end gap-[1.6rem] py-8',
        isMobile ? 'flex-col-reverse gap-[0.8rem]' : 'flex-row'
      )}>
      <Button
        variant="outline"
        className={cn(
          'border-[#121212] text-[#121212] hover:bg-black/5 hover:border-[#121212] active:bg-black/10 active:border-[#121212] active:shadow-none'
        )}>
        <a
          href={getLandingPageLink('poplatkova-imunita')}
          target="_blank"
          rel="noopener noreferrer">
          Viac informácií
        </a>
      </Button>
      {!hasUserFeeImmunity && (
        <Button
          variant="accent"
          onClick={() => {
            navigate('/projects')
          }}
          className={cn(
            'relative',
            isMobile ? 'w-full justify-center' : 'min-w-[270px] justify-start'
          )}>
          Získaj poplatkovú imunitu
          <ChevronRight className="size-6" />
        </Button>
      )}
    </div>
  )
}
